import Modal from 'react-bootstrap/Modal';
import { FaPaperPlane } from 'react-icons/fa';
import ActionButtonGradient from '../../../../components/button/ActionButtonGradient';

const SendCalibrationManager = ({show, handleClose, handleOk, title, deadline}) => {
  return (
    <>
      <style>
        {`
          .send-manager-modal .modal-content {
            border: none;
            border-radius: 12px;
            box-shadow: 0 10px 25px rgba(0,0,0,0.15);
          }
          .send-manager-modal .modal-header {
            border-bottom: 1px solid #e9ecef;
            padding: 1.5rem 1.5rem 1rem 1.5rem;
            background-color: #fff;
            border-radius: 12px 12px 0 0;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .send-manager-modal .modal-title {
            font-weight: 600;
            color: #333;
            font-size: 1.125rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            margin: 0;
          }
          .send-manager-modal .modal-body {
            padding: 1rem 1.5rem 1.5rem 1.5rem;
            background-color: #fff;
            font-size: 14px;
            color: #666;
            line-height: 1.5;
            text-align: center;
          }
          .send-manager-modal .modal-footer {
            border-top: 1px solid #e9ecef;
            padding: 1rem 1.5rem 1.5rem 1.5rem;
            background-color: #fff;
            border-radius: 0 0 12px 12px;
            display: flex;
            gap: 0.5rem;
            justify-content: center;
          }
          .send-manager-modal .btn {
            border-radius: 8px;
            padding: 0.5rem 1.25rem;
            font-weight: 500;
            font-size: 14px;
            transition: all 0.2s ease;
          }
          .send-manager-modal .btn-success {
            background-color: #28a745;
            border-color: #28a745;
            color: white;
          }
          .send-manager-modal .btn-success:hover {
            background-color: #218838;
            border-color: #1e7e34;
            transform: translateY(-1px);
            box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
          }
          .send-manager-modal .btn-secondary {
            background-color: #6c757d;
            border-color: #6c757d;
            color: white;
          }
          .send-manager-modal .btn-secondary:hover {
            background-color: #5a6268;
            border-color: #545b62;
            transform: translateY(-1px);
            box-shadow: 0 2px 8px rgba(108, 117, 125, 0.3);
          }
          .send-manager-icon {
            color: #28a745;
            font-size: 1.125rem;
          }
        `}
      </style>
      
      <Modal 
        show={show} 
        onHide={handleClose}
        backdrop="static" 
        centered
        size="md"
        className="send-manager-modal"
      >
        <Modal.Header>
          <Modal.Title>
            <FaPaperPlane className="send-manager-icon" />
            Send to Manager
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-2">Are you sure you want to send your calibration to <strong>{title}</strong> (Manager Phase)?</p>
          <p className="mb-0">Deadline for Manager Phase is <strong>{deadline}</strong></p>
        </Modal.Body>
        <Modal.Footer>
          <ActionButtonGradient
            onClick={handleClose}
            variant='secondary'
            children={"Cancel"}
          />
          <ActionButtonGradient
            onClick={handleOk}
            variant='success'
            children={"Send"}
          />
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default SendCalibrationManager